import SortableController from "./sortable_controller";
import Sortable from "sortablejs";

// Beds reorder within their own room only. The base controller's string
// `group` doubles as the SortableJS group name, and every room's bed list
// shares it, so without `pull`/`put` off a bed could be dropped into another
// room's list while the server only ever moves it within its own room.
export default class extends SortableController {
  protected getSortableOptions(): Sortable.Options {
    return {
      ...super.getSortableOptions(),
      group: { name: this.groupValue, pull: false, put: false },
    };
  }
}
